module.exports = __webpack_public_path__ + "media/components/assets/img/bg/slice-tl-6c8a2410e4f9591c3e6993b2db8cb848.svg";